import React, { useState, useEffect, useRef } from 'react'
import WindowHeader from './WindowHeader'
import Button from '../ActionButton'
import Loader from './Loader'
import api from "./../../services/api";
import {setSessionStorage, getSessionStorage, clearSessionStorage} from "./../../utils/sessionStorage";

import * as S from './styled'
import { TextBox } from '../TextBox/styled'

const Window = ({ brand, mobile }) => {
  
  const [isOpen, setIsOpen] = useState(true);
  //Carrega mensagens do chat
  const [chatMessages, setChatMessages] = useState([]);
  //Variavel para aguardo do callback
  const [isWaiting, setIsWaiting] = useState(false);
  const chatContainer = useRef(null);

  useEffect(() => {
    async function startChat() {
      try{
        setIsWaiting(true)
        const request = await api.get("/start/" + brand)

        if(request.data){
          var startBrand = request.data
          setChatMessages(chatMessages => [...chatMessages, <><TextBox>{startBrand.message}</TextBox></>]);
          setSessionStorage("targetFlow", startBrand.targetFlow)
          setSessionStorage("sessionId", startBrand.sessionId)
          setSessionStorage("lastMessage", startBrand.message)

          for (const [i, button] of startBrand.actions.entries()) {
            setChatMessages(chatMessages => [...chatMessages, <><Button type={button.type} value={button.value} displayName={button.displayName} sendIntent={sendIntent} goBack={goBack} /></>]);
          }
        }else{
          setChatMessages(chatMessages => [...chatMessages, <><TextBox>Ocorreu um erro</TextBox></>]);
        }
        setIsWaiting(false)
      }
      catch(err){
        console.error("ops! ocorreu um erro" + err);
        throw(err)
      }
    }
    startChat()
    if (chatContainer) {
      chatContainer.current.addEventListener('DOMNodeInserted', event => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight, behavior: 'smooth' });
      });
    }
  }, []);

  const closeChat = () => {
    try {
      window.top.postMessage({
        event: 'chatbot_interaction_close',
        action: 'fechar',
        bot_message: getSessionStorage("lastMessage"), //'<<Última mensagem do bot mostrada para a pessoa antes dela fechar>>'
      }, document.referrer);
    } catch(e) {
      console.log("erro",e)
    }
    setIsOpen(!isOpen)
  }

  const sendIntent = async (props) => {
    const request = await api.post("/chat/", {
          "message": props.value,
          "targetFlow": getSessionStorage("targetFlow"),
          "sessionId": getSessionStorage("sessionId"),
          "type": "intent",
          "brand": brand
    })

    if(request.data){
      try {
        window.top.postMessage({
          event: 'chatbot_interaction_send_intent',
          action: props.value, // Opção selecionada pela pessoa.
          bot_message: getSessionStorage("lastMessage"), //'<<Mensagem atual que a pessoa acabou de responder>>',
          bot_next_message: request.data.message // Próxima mensagem que será mostrada.
        }, document.referrer);
      } catch(e) {}

      const chatResponse = request.data
      setChatMessages(chatMessages => [...chatMessages, <><TextBox>{chatResponse.message}</TextBox></>]);
      setSessionStorage("lastMessage", chatResponse.message)

      for (const [i, button] of chatResponse.actions.entries()) {
        setChatMessages(chatMessages => [...chatMessages, <><Button type={button.type} value={button.value} displayName={button.displayName} sendIntent={sendIntent} goBack={goBack} /></>]);
      }
      clearSessionStorage("targetFlow")
    }
  }

  const goBack = async (props) => {

    const request = await api.post("/chat/", {
      "message": "back",
      "targetFlow": props.value,
      "sessionId": getSessionStorage("sessionId"),
      "type": "back",
      "brand": brand
    })
    
    if(request.data){
      try {
        window.top.postMessage({
          event: 'chatbot_interaction_go_back',
          action: 'voltar',
          bot_message: getSessionStorage("lastMessage"), //'<<Mensagem atual que estava sendo mostrada pela pessoa e ela não respondeu>>',
          bot_next_message: request.data.message // Mensagem da etapa anterior que será mostrada novamente.
        }, document.referrer);
      } catch(e) {}
      
      const chatResponse = request.data
      setSessionStorage("targetFlow",props.value == null? "" : props.value)
      setChatMessages(chatMessages => [...chatMessages, <><TextBox>{chatResponse.message}</TextBox></>]);
      setSessionStorage("lastMessage", chatResponse.message)

      for (const [i, button] of chatResponse.actions.entries()) {
        setChatMessages(chatMessages => [...chatMessages, <><Button type={button.type} value={button.value} displayName={button.displayName} sendIntent={sendIntent} goBack={goBack} /></>]);
      }
    }
  }

  return (
    <S.Main
      id='window-main'
      mobile={mobile}
      className={ isOpen ? '' : 'close-animation' }
    >
      <WindowHeader />
      <S.InnerContainer mobile={mobile} >
        <S.ChatContainer ref={chatContainer} mobile={mobile} >
          <S.ChatInit mobile={mobile} />
          {
            isWaiting ? <Loader position="center" /> : (
            <>
              {chatMessages}
            </>
            )
          }
        </S.ChatContainer>
      </S.InnerContainer>
    </S.Main>
  )
}

export default Window